export const baseURL = process.env.REACT_APP_API2_URL;
export const csrfCookie = '/sanctum/csrf-cookie';
export const login = '/login';
export const logout = '/logout';



// WEBPACK FOOTER //
// ./src/common/util/auth/apiURL.js